module.exports = "https://www.gc-pro.gnp.com.mx/299be89a4c5abe1be391cd022193c7e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/x.svg
// module id = 158
// module chunks = 0